import Image from "next/image";

interface LoadingProps {
    loadingText?: string;
    className?: string;
    style?: "spinner" | "animation";
}

export const Loading = ({
    loadingText = "טוען...",
    className = "py-24",
    style = "animation",
}: LoadingProps) => {
    return (
        <div
            className={`flex-1 flex flex-col items-center h-full justify-evenly gap-4 ${className}`}
        >
            {style === "spinner" ? (
                <div className="relative w-16 h-16">
                    {/* Outer ring */}
                    <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[var(--primary-color)] animate-spin"></div>
                    {/* Inner ring */}
                    <div
                        className="absolute inset-2 rounded-full border-4 border-transparent border-b-[var(--secondary-color)] animate-spin"
                        style={{
                            animationDirection: "reverse",
                            animationDuration: "0.8s",
                        }}
                    ></div>
                    {/* Center dot */}
                    <div className="absolute top-1/2 left-1/2 w-2 h-2 bg-[var(--primary-color)] rounded-full transform -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
                </div>
            ) : style === "animation" ? (
                <Image
                    src="/images/loading.gif"
                    width={300}
                    height={300}
                    alt="Loading"
                    priority
                />
            ) : (
                <></>
            )}
            <h2 className="max-w-[50dvw] text-center">{loadingText}</h2>
            <div />
        </div>
    );
};
